import axios from '../../helpers/axios-setup';

export interface LoginForm {
  login: string;
  password: string;
}

export const login = (data: LoginForm) => axios.post(`/dev/login`, data);
